import { useGetUserStudies } from './get-user-studies/hook';

export const Studies = {
  useGetUserStudies,
};
